import { render, staticRenderFns } from "./individualTestSetupTable.vue?vue&type=template&id=89920c8a&scoped=true"
import script from "./individualTestSetupTable.vue?vue&type=script&lang=js"
export * from "./individualTestSetupTable.vue?vue&type=script&lang=js"
import style0 from "./individualTestSetupTable.vue?vue&type=style&index=0&id=89920c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89920c8a",
  null
  
)

export default component.exports